/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: { size: { type: 'variant', values: [ 'small' ] } },
  rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 2 } } ],
  tokens: {
    fullScreenOverLayBackground: 'rgba(255, 255, 255, 0.97)',
    size: 48,
    thickness: 4
  }
}
export default theme
